import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
export var afterSaleDetailRoute = [{
  path: "after-sale-detail/:id",
  name: "afterSaleDetail",
  component: function component() {
    return import( /* webpackChunkName: "login" */"./after-sale-detail.vue");
  }
}];